import moment from 'moment';

const parseSabreText = (text) => {
  // Normalize Windows vs Unix line endings
  text = text.replace(/\r\n/g, '\n');

  let sections = text.split("\n");
  let locatorSection = sections[0].trim();

  let remainingSection = text.replace(locatorSection, "");
  sections = remainingSection.split("INVOICED");

  let passengerSection = sections[0];
  let remainingSections = sections[1];
  passengerSection = passengerSection.replace(/OPERATED BY FLYDUBAI/g, "");

  // Match passenger names (e.g., 1.1SAEED/KURRAM MR, 2.1SMITH/JANE MRS)
  let rawPaxMatches = passengerSection.split("TKT/TIME LIMIT")[0].match(/\d+\.\d+[A-Z/\s]+?(?:MRS|MR|MSTR|MISS|MS)/g) || [];
  let passgengerNames = rawPaxMatches.map(x => x.replace(/^\s*\d+\.\d+/, "").trim());

  let flightSection = "";
  if (passgengerNames.length > 0) {
    let lastPax = rawPaxMatches[rawPaxMatches.length - 1];
    let afterPax = passengerSection.split(lastPax)[1] || passengerSection;
    flightSection = afterPax.split("TKT/TIME LIMIT")[0];
  } else {
    flightSection = passengerSection.split("TKT/TIME LIMIT")[0];
  }

  flightSection = flightSection.replace(/\s+CNN\n/g, "\n");
  flightSection = flightSection.replace(/\s+INF\n/g, "\n");
  flightSection = flightSection.replace(/\s+pax names\n/g, "\n");

  let flightGroups = flightSection.split("/E");
  let flights = [];

  for (let flightString of flightGroups) {
    // Extract airline locator e.g. /DCCZ*MEY1VV or /DCEK*JHI5UW
    let vendorLocator = null;
    const locMatch = flightString.match(/\/DC([A-Z0-9]{2})\*([A-Z0-9]+)/i);
    if (locMatch && locMatch[2]) {
      vendorLocator = locMatch[2].trim();
    }

    // Match flight line: Segment Airline FlightNumber Class Date Day Origin Dest Status DepTime ArrTime
    // Handles both joined codes ("1 CZ6038Q 15SEP 2 LHECAN HK1  2145  0615")
    // and spaced codes ("1 EK  28L 01DEC 7 GLADXB*HK5  1300  0030")
    const lineMatch = flightString.match(/^\s*\d+\s+([A-Z0-9]{2})\s*(\d+)\s*([A-Z])\s+(\d{2}[A-Z]{3})\s+\d\s+([A-Z]{3})([A-Z]{3})(?:\*|\s+)([A-Z0-9]+)\s+(\d{4})\s+(\d{4})/m);

    if (lineMatch) {
      const airline = lineMatch[1];
      const flightNumber = lineMatch[2];
      const flightClass = lineMatch[3];
      const travelDate = lineMatch[4];
      const flyFrom = lineMatch[5];
      const flyTo = lineMatch[6];
      const statusCode = lineMatch[7];
      const departTime = lineMatch[8];
      const airTime = lineMatch[9];

      let formattedTravelDate = moment(travelDate, "DDMMM").isValid()
        ? moment(travelDate, "DDMMM").format('DD-MMM-YYYY')
        : travelDate;

      let status = "Confirm";
      if (statusCode.includes("HK") || statusCode.includes("RR")) {
        status = "Confirm";
      } else if (statusCode.includes("HX") || statusCode.includes("UN") || statusCode.includes("NO") || statusCode.includes("UC")) {
        status = "Cancelled";
      }

      flights.push({
        airline: airline,
        flightClass: flightClass,
        flightNumber: flightNumber,
        flightDate: formattedTravelDate,
        flyFrom: flyFrom,
        flyTo: flyTo,
        status: status,
        departureTime: departTime,
        airTime: airTime,
        vendorLocator: vendorLocator
      });
    }
  }

  let tickets = [];
  let accounts = [];
  if (remainingSections != undefined) {
    let bottomSections = remainingSection.split("ACCOUNTING DATA")[1];
    if (bottomSections) {
      let accountSection = bottomSections.split("TKT/TIME LIMIT")[0];

      let accountPattern = /\d+\.\s*([A-Z0-9¥]+)\/\s*([\d.]*)\/\s*([\d.]+)\/\s*([\d.]+)\/(ONE|TWO|THREE|FOUR|FIVE|SIX|SEVEN|EIGHT|NINE|TEN)/gm;
      let match;
      while ((match = accountPattern.exec(accountSection)) !== null) {
        let ticket = match[1].trim();
        tickets.push(ticket);

        let taxPrice = parseFloat(match[3]) || 0;
        let costPrice = parseFloat(match[4]) || 0;
        let salePrice = (costPrice + taxPrice).toFixed(2);

        accounts.push({
          costPrice: costPrice.toFixed(2),
          taxPrice: taxPrice.toFixed(2),
          salePrice: salePrice
        });
      }
    }
  }

  let passengers = [];
  for (let i = 0; i < passgengerNames.length; i++) {
    let ticketNumber = tickets[i] || "";
    let gross = "0.00";
    let taxes = "0.00";
    let netPrice = "0.00";

    if (accounts[i]) {
      gross = accounts[i].salePrice;
      taxes = accounts[i].taxPrice;
      netPrice = accounts[i].costPrice;
    }

    passengers.push({
      name: passgengerNames[i],
      dateOfBirth: "",
      passport: "",
      ticketNumber: ticketNumber,
      netPrice: netPrice,
      taxes: taxes,
      gross: gross
    });
  }

  // Extract clean 6-character PNR if remarks/comments exist on line 1
  let cleanPnr = locatorSection;
  const pnrMatch = locatorSection.match(/^([A-Z0-9]{6})/);
  if (pnrMatch) {
    cleanPnr = pnrMatch[1];
  }

  let vendorLocator = null;
  if (flights.length > 0 && flights[0].vendorLocator) {
    vendorLocator = flights[0].vendorLocator;
  }

  return {
    locator: vendorLocator,
    passengerNames: passgengerNames,
    flights: flights,
    acounts: accounts,
    tickets: tickets,
    passengers: passengers,
    vendorLocator: cleanPnr
  };
};

const parseBtresText = (text) => {
  let locator = null;
  let vendorLocator = null;
  let flights = [];
  let passengers = [];
  let atol = 0;
  let bookingFee = 0;

  const recLocMatch = text.match(/\d{2}:\d{2}\s*([A-Z0-9]{6})\s+ARF\s+BTRES/);
  if (recLocMatch && recLocMatch[1]) vendorLocator = recLocMatch[1];

  const bookingRefMatch = text.match(/Booking Ref\.\s*([A-Z0-9]+)/);
  if (bookingRefMatch && bookingRefMatch[1]) locator = bookingRefMatch[1];
  if (!vendorLocator) vendorLocator = locator;

  const flightSectionSplit = text.split(/Flight Details[\s\S]*?Class/);
  if (flightSectionSplit.length > 1) {
    const flightSection = flightSectionSplit[1].split(/Segment Related Text/)[0];
    const segmentRegex = /(?:^|\s*)(\d+)\s*([\s\S]+?)\(([A-Z]{3})\)\s*([A-Za-z]{3},\s*\d{2}\s*[A-Za-z]{3}\s*\d{4})\s*(\d{2}:\d{2})\s*Terminal:\s*[^\s]+?\s*([\s\S]+?)\(([A-Z]{3})\)\s*([A-Za-z]{3},\s*\d{2}\s*[A-Za-z]{3}\s*\d{4})\s*(\d{2}:\d{2})\s*Terminal:\s*([^(]+)\(([A-Z0-9]+)\)\s*[^(]+\(([A-Z])\)/g;

    let match;
    while ((match = segmentRegex.exec(flightSection)) !== null) {
      const flyFrom = match[3];
      const fromDateRaw = match[4].replace(/\s+/g, ' ');
      const departTime = match[5];
      const flyTo = match[7];

      const airlineStr = match[10].trim();
      const flightCodeRaw = match[11].trim();
      const flightClass = match[12];

      const airlinePrefixMatch = flightCodeRaw.match(/^([A-Z0-9]{2})(\d+)/);
      let airline = airlinePrefixMatch ? airlinePrefixMatch[1] : airlineStr;
      let flightNumber = airlinePrefixMatch ? airlinePrefixMatch[2] : flightCodeRaw;

      const dateParts = fromDateRaw.split(' ');
      const formattedTravelDate = dateParts.length === 4 ? `${dateParts[1]}-${dateParts[2]}-${dateParts[3]}` : fromDateRaw;

      flights.push({
        airline, flightClass, flightNumber, flightDate: formattedTravelDate,
        flyFrom, flyTo, status: 'Confirm', departureTime: departTime, airTime: '', vendorLocator: vendorLocator || ""
      });
    }
  }

  const passengerSectionSplit = text.split(/Passenger & Charge Details[\s\S]*?E-Ticket/);
  if (passengerSectionSplit.length > 1) {
    const passengerSection = passengerSectionSplit[1].split(/Total/)[0];

    const namePattern = /([a-zA-Z\s*.\-()]+)\s+([A-Z]{4,10})\s+Fare\s+\d+\s+([\d.]+)\s+([\d.]+)(?:\s+([\d-]{10,}))?/g;
    let nMatch;
    const tempPax = [];
    while ((nMatch = namePattern.exec(passengerSection)) !== null) {
      tempPax.push({
        name: nMatch[1].trim(),
        type: nMatch[2].trim(),
        fare: parseFloat(nMatch[3]),
        taxes: 0,
        gross: parseFloat(nMatch[3]),
        ticketNumber: nMatch[5] || ""
      });
    }

    const taxPattern = /Taxes\s+\d+\s+([\d.]+)\s+([\d.]+)/g;
    let tMatch;
    let tIndex = 0;
    while ((tMatch = taxPattern.exec(passengerSection)) !== null) {
      if (tIndex < tempPax.length) {
        tempPax[tIndex].taxes += parseFloat(tMatch[1]);
        tempPax[tIndex].gross += parseFloat(tMatch[1]);
        tIndex++;
      }
    }

    tempPax.forEach(p => {
      passengers.push({
        name: p.name,
        dateOfBirth: "",
        passport: "",
        ticketNumber: p.ticketNumber,
        netPrice: p.gross.toFixed(2),
        taxes: p.taxes.toFixed(2),
        gross: p.gross.toFixed(2)
      });
    });

    const atolPattern = /ATOL[\s\w]*?\s+\d+\s+([\d.]+)/gi;
    let aMatch;
    while ((aMatch = atolPattern.exec(passengerSection)) !== null) {
      atol += parseFloat(aMatch[1]);
    }

    const bookingFeePattern = /Booking\s+Fee[\s\w]*?\s+\d+\s+([\d.]+)/gi;
    let bMatch;
    while ((bMatch = bookingFeePattern.exec(passengerSection)) !== null) {
      bookingFee += parseFloat(bMatch[1]);
    }
  }

  return { locator: locator || vendorLocator, vendorLocator: vendorLocator, flights, passengers, atol, bookingFee };
};

const parseTkConnectText = (text) => {
  // Normalize Windows vs Unix line endings from clipboard
  text = text.replace(/\r\n/g, '\n');

  let locator = null;
  let vendorLocator = null;
  let flights = [];
  let passengers = [];

  // 1. Extract Order ID e.g. "Order ID\nWGWNC8"
  const orderIdMatch = text.match(/Order ID\n([A-Z0-9]{6})/);
  if (orderIdMatch && orderIdMatch[1]) {
    vendorLocator = orderIdMatch[1];
  }
  locator = vendorLocator;

  // 2. Extract flights from coupon table
  //    Format OLD: "TK1344\nAirbus A330\nEdinburgh (EDI) • 10:40\n01 Oct, Thu\nIstanbul (IST) • 17:05"
  //    Format NEW: "TK1346\nEdinburgh (EDI) • 16:55\n13 Aug, Thu\nIstanbul (IST) • 23:15" (no aircraft line)
  //    The optional group (?:[^\n(]+\n)? skips the aircraft description only — city lines contain
  //    parentheses so [^\n(]+ cannot consume them, triggering safe backtracking.
  const flightRegex = /(TK\d+)\n(?:[^\n(]+\n)?([A-Za-z][A-Za-z\s]*)\(([A-Z]{3})\)\s*•\s*(\d{2}:\d{2})\n(\d{2}\s+\w+),\s+\w+\n([A-Za-z][A-Za-z\s]*)\(([A-Z]{3})\)/g;
  let fMatch;
  while ((fMatch = flightRegex.exec(text)) !== null) {
    const flightCode = fMatch[1];
    const airline = flightCode.substring(0, 2);
    const flightNumber = flightCode.substring(2);
    const flyFrom = fMatch[3];
    const depTime = fMatch[4];
    const rawDate = fMatch[5].trim(); // e.g. "01 Oct"
    const flyTo = fMatch[7];
    const dateParts = rawDate.split(' ');
    const formattedDate = dateParts[0] + '-' + dateParts[1];

    flights.push({
      airline: airline,
      flightNumber: flightNumber,
      flightClass: '',
      flightDate: formattedDate,
      flyFrom: flyFrom,
      flyTo: flyTo,
      status: 'Confirm',
      departureTime: depTime,
      airTime: '',
      vendorLocator: vendorLocator || ""
    });
  }

  // 3. Extract passenger section – supports TWO TK Connect portal layouts:
  //    FORMAT A (old): header contains "Ticket Number Price"; each row has a GBP price.
  //    FORMAT B (new): header contains "Passenger Name … Ticket Number" (no Price column);
  //                    ticket appears after a dash (YYYY-TICKETNUM) or on its own next line.
  const paxSectionMatchOld = text.match(/Ticket Number Price\n([\s\S]*?)(?:\nBaggage|\nAncillary|$)/);
  const paxSectionMatchNew = !paxSectionMatchOld
    ? text.match(/Passenger Name[^\n]*Ticket Number\n([\s\S]*?)(?=Baggage|Click here|$)/)
    : null;

  if (paxSectionMatchOld) {
    // ── FORMAT A: anchor on 13-digit ticket number + GBP price ──────────────
    // Handles: multi-line names, names split across lines, multi-word types (VFR Infant),
    // and portal layout where two names share a cell.
    const paxSection = paxSectionMatchOld[1];

    const ticketRegex = /(\d{13})\s+GBP\s+([\d,]+(?:\.\d+)?)/g;
    const tickets = [];
    let tM;
    while ((tM = ticketRegex.exec(paxSection)) !== null) {
      tickets.push({ ticket: tM[1], gross: tM[2], start: tM.index, end: tM.index + tM[0].length });
    }

    let prevEnd = 0;
    tickets.forEach(({ ticket, gross, start, end }) => {
      // The block of text before this ticket contains the name, type and DOB
      const block = paxSection.substring(prevEnd, start);
      prevEnd = end;

      // Flatten line breaks to single spaces for easier matching
      const flat = block.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();

      // Extract DOB: "DD Mon, YYYY"
      const dobMatch = flat.match(/(\d{1,2}\s+\w+,\s+\d{4})/);
      const dob = dobMatch ? dobMatch[1] : '';

      // Strip everything from the pax type keyword onwards (type, DOB, contact)
      // This leaves only the raw name portion(s)
      const typeIdx = flat.search(/(VFR|Adult|Child|Infant|Youth|Senior)/i);
      const namePart = typeIdx > -1 ? flat.substring(0, typeIdx).trim() : flat;

      // Split by title prefixes to handle cases where two names are joined in one cell
      // e.g. "Ms. Hammera AKHTAR Mstr. Muhammadayaan OMAIR" → ["Ms. Hammera AKHTAR", "Mstr. Muhammadayaan OMAIR"]
      const titleParts = namePart.split(/((?:Mr|Ms|Mrs|Dr|Master|Mstr)\.\s)/);
      const nameSegments = [];
      for (let i = 1; i < titleParts.length; i += 2) {
        if (titleParts[i]) {
          const combined = (titleParts[i] + (titleParts[i + 1] || '')).trim();
          nameSegments.push(combined);
        }
      }

      // When two names are jammed together (portal layout bug), use the FIRST one
      const name = (nameSegments.length > 0 ? nameSegments[0] : namePart).toUpperCase();
      const cleanGross = parseFloat(gross.replace(/,/g, ''));

      passengers.push({
        name:         name,
        dateOfBirth:  dob,
        passport:     '',
        ticketNumber: ticket,
        netPrice:     cleanGross.toFixed(2),
        taxes:        '0.00',
        gross:        cleanGross.toFixed(2)
      });
    });

  } else if (paxSectionMatchNew) {
    // ── FORMAT B: line-by-line parser ────────────────────────────────────────
    // Each passenger row starts with a title (Mr./Ms./Mrs./Dr./Mstr./Master.).
    // Ticket number is either:
    //   • dash-joined to the DOB year:  "03 Jan, 1996-2352244732112"
    //   • on its own continuation line: "2352244732111"
    // Phone numbers (+44...) and email lines are safely ignored.
    const paxSection = paxSectionMatchNew[1];
    const lines = paxSection.split('\n');
    let currentPax = null;

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) continue;

      // Detect the start of a new passenger row by title prefix
      const titleMatch = trimmed.match(/^(Mr\.|Ms\.|Mrs\.|Dr\.|Mstr\.|Master\.)\s+(.+)/i);
      if (titleMatch) {
        if (currentPax) passengers.push(currentPax); // save previous passenger

        const rest = titleMatch[2];

        // Extract DOB: "DD Mon, YYYY"
        const dobMatch = rest.match(/(\d{1,2}\s+\w+,\s+\d{4})/);
        const dob = dobMatch ? dobMatch[1] : '';

        // Extract ticket: looks for YYYY-TICKETNUM (dash immediately after year)
        // This avoids false-matching phone numbers which are preceded by + not a digit
        const dashTicketMatch = rest.match(/\d{4}-(\d{10,13})(?:\s|$)/);
        const ticketNumber = dashTicketMatch ? dashTicketMatch[1] : '';

        // Extract name: everything before the passenger type keyword
        const typeIdx = rest.search(/(VFR|Adult|Child|Infant|Youth|Senior|CHD|INF|ADT|CNN)/i);
        let namePart;
        if (typeIdx > -1) {
          namePart = rest.substring(0, typeIdx).trim();
        } else if (dobMatch) {
          namePart = rest.substring(0, rest.indexOf(dob)).trim();
        } else {
          namePart = rest;
        }

        const fullName = (titleMatch[1] + ' ' + namePart).trim().toUpperCase();

        currentPax = {
          name:         fullName,
          dateOfBirth:  dob,
          passport:     '',
          ticketNumber: ticketNumber,
          netPrice:     '0.00',
          taxes:        '0.00',
          gross:        '0.00'
        };
      } else if (currentPax && !currentPax.ticketNumber) {
        // Continuation line – could be email, phone, or a standalone ticket number.
        // Only accept a line that is purely 10-13 digits (no letters, no + prefix).
        const ticketOnlyMatch = trimmed.match(/^(\d{10,13})$/);
        if (ticketOnlyMatch) {
          currentPax.ticketNumber = ticketOnlyMatch[1];
        }
      }
    }

    if (currentPax) passengers.push(currentPax); // push the last passenger
  }

  return {
    locator: locator,
    vendorLocator: vendorLocator,
    flights: flights,
    passengers: passengers,
    atol: 0,
    bookingFee: 0
  };
};

const parseEmiratesText = (text) => {
  // Normalize Windows clipboard line endings
  text = text.replace(/\r\n/g, '\n');

  let locator = null;
  let vendorLocator = null;
  let flights = [];
  let passengers = [];

  // 1. Extract PNR (booking ref) e.g. "PNR:  OGNFYB / F1"
  const pnrMatch = text.match(/PNR:\s*([A-Z0-9]+)\s*\//);
  if (pnrMatch && pnrMatch[1]) locator = pnrMatch[1];

  // 2. Extract Vendor Locator e.g. "NS4QYW / EK"
  const vendorMatch = text.match(/([A-Z0-9]{6})\s*\/\s*EK/);
  if (vendorMatch && vendorMatch[1]) vendorLocator = vendorMatch[1];
  if (!vendorLocator) vendorLocator = locator;

  // 3. Extract flights from Coupons table
  //    Format: "1  O  EK  28  T  11MAY  GLA  DXB  14:40  OK ..."
  const flightRegex = /\d+\s+[OX]\s+([A-Z]{2})\s+(\d+)\s+([A-Z])\s+(\d{2}[A-Z]{3})\s+([A-Z]{3})\s+([A-Z]{3})\s+(\d{2}:\d{2})/g;
  let fMatch;
  while ((fMatch = flightRegex.exec(text)) !== null) {
    const rawDate = fMatch[4]; // e.g. "11MAY"
    const day = rawDate.substring(0, 2);
    const month = rawDate.substring(2);
    const formattedDate = day + '-' + month;

    flights.push({
      airline: fMatch[1],
      flightNumber: fMatch[2],
      flightClass: fMatch[3],
      flightDate: formattedDate,
      flyFrom: fMatch[5],
      flyTo: fMatch[6],
      status: 'Confirm',
      departureTime: fMatch[7],
      airTime: '',
      vendorLocator: vendorLocator || ""
    });
  }

  // 4. Extract passenger name & type e.g. "KHAN / MUHAMMAD ASAD(ADT)"
  const paxMatch = text.match(/([A-Z]+)\s*\/\s*([A-Z\s]+)\((ADT|CHD|INF|CNN|GBE)\)/);
  if (paxMatch) {
    const surname = paxMatch[1].trim();
    const firstname = paxMatch[2].trim();
    const name = firstname + ' ' + surname;

    // 5. Extract ticket number e.g. "TKT:  1765010189180"
    const tktMatch = text.match(/TKT:\s*(\d+)/);
    const ticketNumber = tktMatch ? tktMatch[1] : '';

    // 6. Extract fare
    const fareMatch = text.match(/FARE:\s+GBP\s+([\d.]+)/);
    const fare = fareMatch ? parseFloat(fareMatch[1]) : 0;

    // 7. Sum all TAX lines
    const taxLinePattern = /TAX:\s+GBP\s+([\d.]+)/g;
    let taxes = 0;
    let tMatch;
    while ((tMatch = taxLinePattern.exec(text)) !== null) {
      taxes += parseFloat(tMatch[1]);
    }

    const total = fare + taxes;
    passengers.push({
      name: name.toUpperCase(),
      dateOfBirth: '',
      passport: '',
      ticketNumber: ticketNumber,
      netPrice: total.toFixed(2),
      taxes: taxes.toFixed(2),
      gross: total.toFixed(2)
    });
  }

  return {
    locator: locator || vendorLocator,
    vendorLocator: vendorLocator,
    flights: flights,
    passengers: passengers,
    atol: 0,
    bookingFee: 0
  };
};

export default {
  parseSabreText,
  parseBtresText,
  parseTkConnectText,
  parseEmiratesText
};